import { dimension } from 'newclick-alfa-metrics';

export type FormStatus = 'Submit' | 'Invalid';
export type ShowPage = 'Main' | 'Error' | 'Success' | 'Collection Completed' | 'Link Invalid';

export const analyticsConfig = {
    SHOW_PAGE: {
        category: 'WEB_PAGE_EVENTS',
        label: 'Show Web Page',
        action: 'impression',
        dimensions: {
            screen: dimension<ShowPage>(20)
        }
    },
    SUBMIT_FORM: {
        category: 'WEB_PAGE_EVENTS',
        label: 'Submit Button Click',
        action: 'submit',
        dimensions: {
            result: dimension<FormStatus>(20)
        }
    },
    GO_TO_APPLICATION: {
        category: 'WEB_PAGE_EVENTS',
        label: 'Click Deeplink',
        action: 'click'
    }
};

/* eslint-disable @typescript-eslint/no-empty-interface */
declare module 'newclick-alfa-metrics/config-type' {
    type AnalyticsConfigType = typeof analyticsConfig;

    interface AlfaMetricsEventsConfig extends AnalyticsConfigType {}
}
